import type { EndpointBuilder } from '@reduxjs/toolkit/query';

import type { DynamicBaseQueryFn } from '../../../utils/create-dynamic-base-query';

export const tagTypes = ['Metrics', 'Logs', 'LogDownload', 'CmiConfig'] as const;

export type TagType = (typeof tagTypes)[number];

export type Builder = EndpointBuilder<DynamicBaseQueryFn, TagType, 'opsApi'>;
